import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api"
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            const url = config.url || "";

            // ❌ не додаємо токен до:
            // /auth/*  (логін)
            // /public/* (публічні дані)
            const isAuthRoute = url.startsWith("/auth/");
            const isPublicRoute = url.startsWith("/public/");

            if (!isAuthRoute && !isPublicRoute) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
